import React from 'react'
import { useWeb3React } from '@web3-react/core'
import { Colors } from 'src/constants'
import { useTokenMigration } from 'src/hooks'

import {
  Box,
  TitleH2,
  FinePrint,
  Button,
  Row,
  WalletInformation,
  Error,
  Warning,
  ConnectWalletInterface,
} from '../index'

// Component specific styled components
import {
  RecentTransactions,
  MigrationInterfaceContainer,
  Overlay,
} from './components'
import { BodyText } from '../Typography'
import { utils } from 'ethers'

export const MigrationInterface = () => {
  const { active, account, chainId } = useWeb3React()

  // To Do - Get old + new balance into this component
  const {
    hasClaimableTokens,
    hasApproved,
    onApproveClicked,
    onClaimClicked,
    isLoading,
    error,
    oldBalance,
    newBalance,
  } = useTokenMigration()
  const hasClaimed = hasApproved && !hasClaimableTokens

  if (!active) {
    return (
      <Overlay>
        <ConnectWalletInterface />
      </Overlay>
    )
  }

  return (
    <Overlay>
      <MigrationInterfaceContainer>
        <Box marginBottom="l">
          <Row justifyContent="center" alignItems="center">
            <WalletInformation />
          </Row>
        </Box>
        <Box backgroundColor={Colors.WOODSMOKE_LIGHT} roundedCorners>
          <Box roundedCorners padding="l" marginBottom="l">
            <Box marginBottom="m">
              <TitleH2>Migrate your tokens</TitleH2>
            </Box>

            {hasClaimed ? (
              <>
                <Box marginBottom="l">
                  <Box marginBottom="m">
                    <BodyText>
                      You have successfully migrated your tokens! <br /> <br />
                      You now own {utils.formatEther(newBalance)} ARCx tokens.
                    </BodyText>
                  </Box>
                </Box>
              </>
            ) : (
              <>
                <Box marginBottom="m">
                  <Row>
                    <Box marginBottom="s">
                      <Row>
                        <Box marginRight="s">
                          <FinePrint
                            style={{ color: Colors.WHITE }}
                          >{`Current Balance:`}</FinePrint>
                        </Box>
                        <FinePrint
                          style={{ color: Colors.WHITE }}
                        >{`${utils.formatEther(
                          oldBalance,
                        )} ARCx (old)`}</FinePrint>
                      </Row>
                    </Box>
                  </Row>
                  <Row>
                    <Box>
                      <Row>
                        <Box marginRight="s">
                          <FinePrint
                            style={{ color: Colors.WHITE }}
                          >{`What you'll get:`}</FinePrint>
                        </Box>
                        <FinePrint
                          style={{ color: Colors.WHITE }}
                        >{`${utils.formatEther(
                          oldBalance.mul(10000),
                        )} ARCx (new)`}</FinePrint>
                      </Row>
                    </Box>
                  </Row>
                </Box>
                <Box marginBottom="l">
                  <Warning
                    warningText={
                      <>
                        {'The ARCx token migration will be a 1:10,000 split.'}{' '}
                        <br />
                        <br />
                        {
                          'As an indication, if you hold 1 ARCx worth $10,000 pre-split, you would get 10,000 ARCx post split, each worth $1.00. '
                        }{' '}
                        <br />
                        <br />
                        {
                          'The original ARCx Governance Token will be called the ‘Old ARCx Governance Token’ and the new token post-split will simply be referred to as the ‘ARCx Governance Token’.'
                        }{' '}
                        <br />
                        <br />
                      </>
                    }
                  />
                </Box>
                <Row justifyContent="space-between">
                  <Button
                    onClick={onApproveClicked}
                    size="l"
                    text={'Approve'}
                    buttonType="primary"
                    disabled={!(hasClaimableTokens && !hasApproved)}
                    loading={isLoading}
                    fullWidth
                  />
                  <Box margin="s" />
                  <Button
                    size="l"
                    text={'Confirm'}
                    buttonType="primary"
                    onClick={onClaimClicked}
                    disabled={!(hasClaimableTokens && hasApproved)}
                    loading={isLoading}
                    fullWidth
                  />
                </Row>
              </>
            )}
          </Box>
          <Box roundedCorners backgroundColor={Colors.WOODSMOKE} padding="l">
            <Box>
              <Row justifyContent="center">
                <RecentTransactions address={account} chainId={chainId} />
              </Row>
            </Box>
          </Box>
        </Box>
        {!!error && (
          <Box marginTop="m">
            <Error errorText={error} />
          </Box>
        )}
      </MigrationInterfaceContainer>
    </Overlay>
  )
}
